module.exports = __webpack_public_path__ + "res/ic_menu_play_st.62393afefa68be1f7d6892298dfc0215.png";